import { render, staticRenderFns } from "./LessInfo.vue?vue&type=template&id=72f2c4b4&"
import script from "./LessInfo.vue?vue&type=script&lang=js&"
export * from "./LessInfo.vue?vue&type=script&lang=js&"
import style0 from "./LessInfo.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports